import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default function Calendar({ selected, onSelect }) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const [cursor, setCursor] = useState(new Date(today.getFullYear(), today.getMonth(), 1));

  const year = cursor.getFullYear(), month = cursor.getMonth();
  const firstDow = new Date(year, month, 1).getDay();
  const days = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);

  const fmt = (d) => `${year}-${String(month + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

  return (
    <div className="cal" data-testid="calendar">
      <div className="cal-head">
        <button className="cal-nav" onClick={() => setCursor(new Date(year, month - 1, 1))} data-testid="cal-prev"><ChevronLeft size={16} /></button>
        <b>{MONTHS[month]} {year}</b>
        <button className="cal-nav" onClick={() => setCursor(new Date(year, month + 1, 1))} data-testid="cal-next"><ChevronRight size={16} /></button>
      </div>
      <div className="cal-grid">
        {DOW.map(d => <div className="cal-dow" key={d}>{d}</div>)}
        {cells.map((d, i) => {
          if (!d) return <div key={i} className="cal-day muted" />;
          const date = new Date(year, month, d);
          const past = date < today;
          const sel = selected === fmt(d);
          return (
            <button key={i}
              className={`cal-day ${past ? "past" : ""} ${sel ? "sel" : ""}`}
              disabled={past}
              onClick={() => onSelect(fmt(d))}
              data-testid={`cal-day-${fmt(d)}`}>
              {d}
            </button>
          );
        })}
      </div>
    </div>
  );
}
